import { useEffect } from "react";
import { useSetWindowTitle } from "@/components/ui/os-layout";
import { useScopeLabelCache } from "../audits/useScopeLabelCache";
import { ConversationView } from "./ConversationView";

export interface GuardiansConversationWindowProps {
  missionId?: string;
  taskId?: string;
  focus?: string;
}

/** Utility window surface for mission/task conversation history. */
export function GuardiansConversationWindow({
  missionId,
  taskId,
  focus,
}: GuardiansConversationWindowProps) {
  const setWindowTitle = useSetWindowTitle();
  const scopeLabels = useScopeLabelCache([], []);

  useEffect(() => {
    setWindowTitle("Conversation");
  }, [setWindowTitle]);

  if (!missionId && !taskId) {
    return (
      <div
        className="flex h-full items-center justify-center p-6 text-sm text-slate-400"
        data-testid="guardians-conversation-missing"
      >
        Open a conversation from an alert or mission link.
      </div>
    );
  }

  return (
    <div className="h-full min-h-0">
      <ConversationView
        variant="window"
        missionId={missionId}
        taskId={taskId}
        focus={focus}
        scopeLabels={scopeLabels}
      />
    </div>
  );
}
